import { makeStyles } from "../Utilities/ThemeHelper";
export const useStyles = makeStyles(theme => ({
  autoCompleteWrapper: {
    padding: 0,
    "& > div:before": {
      display: "none"
    },
    "& > div:after": {
      display: "none"
    },
    transition: theme.transitions.create("opacity"),
    "& .Mui-disabled": {
      textFillColor: "currentColor"
    }
  },
  autoCompleteLabel: {
    fontWeight: "bold",
    "&[class]": {
      color: theme.palette.primary.main
    }
  },
  clearButton: {
    marginRight: theme.spacing(1)
  },
  disabled: {
    opacity: "50%"
  },
  dropdownInputWrapper: {
    padding: 0,
    fontFamily: theme.typography.fontFamily,
    textAlign: "left",
    flexWrap: "nowrap",
    "&.prmbl-autocomplete__control": {
      minHeight: 56,
      border: "none",
      borderRadius: 2,
      boxShadow: "none",
      cursor: "text",
      backgroundColor: "transparent",
      boxSizing: "border-box"
    },
    "&.prmbl-autocomplete__control:hover": {
      border: "none"
    },
    "&.prmbl-autocomplete__value-container": {
      padding: theme.spacing(1.5),
      minWidth: 52,
      flexWrap: "wrap",
      gap: theme.spacing(1)
    },
    "&.prmbl-autocomplete__input": {
      textAlign: "inherit",
      height: "auto",
      lineHeight: "inherit"
    },
    "&.prmbl-autocomplete__multi-value": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      lineHeight: "1.75",
      fontSize: theme.typography.fontSize,
      margin: 0,
      alignSelf: "stretch",
      overflow: "hidden"
    },
    "&.prmbl-autocomplete__multi-value__label": {
      color: theme.palette.primary.contrastText,
      padding: "3px 3px 3px 6px"
    },
    "&.prmbl-autocomplete__multi-value__remove": {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.primary.contrastText
      }
    },
    "&.prmbl-autocomplete__dropdown-indicator": {
      cursor: "pointer",
      height: "100%",
      alignItems: "center",
      color: theme.palette.grey[400]
    },
    "&.prmbl-autocomplete__dropdown-indicator:hover": {
      color: theme.palette.grey[500]
    },
    "&.prmbl-autocomplete__control--is-focused .prmbl-autocomplete__dropdown-indicator": {
      color: theme.palette.grey[600]
    },
    "&.prmbl-autocomplete__clear-indicator": {
      cursor: "pointer"
    },
    "&.prmbl-autocomplete__indicator": {
      padding: theme.spacing(1)
    },
    "&.prmbl-autocomplete__container": {
      padding: "0px !important"
    },
    "&.prmbl-autocomplete__menu": {
      background: theme.palette.background.paper,
      margin: "0 1px",
      borderRadius: "0 0 2px 2px",
      width: "calc(100% - 2px)",
      borderTop: 0,
      zIndex: "5",
      boxSizing: "border-box"
    },
    "&.prmbl-autocomplete__menu-list": {
      padding: 0,
      ...theme.scrollbars?.main
    },
    "&.prmbl-autocomplete__placeholder": {
      color: theme.palette.text.secondary
    },
    "&.prmbl-autocomplete__group-heading": {
      padding: theme.spacing(1, 2),
      background: theme.palette.background.paper,
      position: "sticky",
      top: 0,
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightBold,
      zIndex: theme.zIndex.modal
    },
    "&.prmbl-autocomplete__single-value": {
      color: theme.palette.text.primary
    },
    "&.prmbl-autocomplete__menu-notice": {
      padding: theme.spacing(1, 1.5)
    }
  },
  dropdownInputWrapperCompact: {
    "&.prmbl-autocomplete__control": {
      minHeight: 35
    },
    "&.prmbl-autocomplete__value-container": {
      padding: "5px 6px"
    },
    "&.prmbl-autocomplete__indicator": {
      padding: theme.spacing(0.5)
    },
    "&.prmbl-autocomplete__multi-value": {
      fontSize: theme.typography.caption.fontSize
    },
    "& .prmbl-autocomplete__multi-value__label-icon svg": {
      width: "1rem",
      height: "1rem"
    },
    "&.prmbl-autocomplete__indicators > .prmbl-iconBtn": {
      padding: 4
    }
  },
  dropdownInputWrapperInline: {
    "&.prmbl-autocomplete__input > input": {
      position: "absolute",
      left: theme.spacing(1.5),
      top: "50%",
      transform: "translateY(-50%)"
    },
    "&.prmbl-autocomplete__single-value": {
      margin: 0
    }
  },
  portalElement: {
    zIndex: theme.zIndex.modal + 1,
    position: "relative"
  },
  readOnly: {
    "& .prmbl-autocomplete__indicators": {
      display: "none"
    },
    "& .prmbl-autocomplete__multi-value__remove": {
      display: "none"
    },
    "& .prmbl-autocomplete__multi-value__label": {
      paddingRight: 6
    }
  }
}));
export default useStyles;